import { isValidElement, type ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  value?: string | number | null;
  label: string;
  ariaLabel: string;
  onClick?: () => void;
  trophy?: boolean;
}

function renderIcon(icon: ReactNode) {
  if (isValidElement(icon)) return icon;
  if (typeof icon === 'string' && icon.length <= 2) {
    return <span className="text-[10px] font-extrabold tracking-wide">{icon}</span>;
  }
  if (typeof icon === 'string') {
    return <span className="text-[11px] font-extrabold tracking-wide">{icon}</span>;
  }
  return icon;
}

export function MemberCardUtilityTile({ icon, value, label, ariaLabel, onClick, trophy }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`flex aspect-square flex-col items-center justify-center gap-0.5 rounded-xl bg-navy p-2 active:scale-[0.98] ${
        trophy
          ? 'border-2 border-gold shadow-[0_4px_14px_rgba(10,30,63,0.28)]'
          : 'border-[1.5px] border-navy'
      }`}
    >
      <div className="flex h-[34px] w-[34px] items-center justify-center rounded-[10px] bg-gold/[0.22] text-gold">
        {renderIcon(icon)}
      </div>
      {value != null && value !== '' && (
        <div className="mt-0.5 font-serif text-[13px] font-extrabold leading-none tracking-[-0.02em] text-gold">
          {value}
        </div>
      )}
      <div className="whitespace-nowrap text-center text-[8.5px] font-bold uppercase leading-tight tracking-[0.04em] text-white/[0.78]">
        {label}
      </div>
    </button>
  );
}
